// extracted by mini-css-extract-plugin
export var content = "_uq-1";
export var wrapper = "_uq-0";